<template>
  <div class="channelsSetup">
    <p>
      Agrega funcionalidades que complementen tu experiencia en {{ companyName }} con nuestras integraciones. 
      <a :href="DOCS_URL" target="_blank" rel="noopener noreferrer">Click aquí</a> para conocer más.
    </p>

    <!-- <a @click="handleLoginHubSpot">Conectar con HubSpot</a> | 
    <a @click="handleListContactsHubSpot">Listar contactos de HubSpot</a>
    <br/> -->
    
    <div class="container">
      <div class="section-channels-cards">
        <CardChannels
          v-for="channel in channelsCustomerConfig"
          :key="channel.id"
          :channel="channel"
          :dataPlan="dataPlan"
          @openModal="handleOpenModal"
        />
      </div>
    </div>
  </div>

  <facebook-channel
    v-if="facebookModal"
    class="setup-modal"
    :open="facebookModal"
    @close="facebookModal = false"
  />

  <!-- TODO: Consider removing "whatsapp-channels" if WhatsAppAutoSetup becomes permanent for all users. -->
  <!-- <whatsapp-channels class="setup-modal" :open="whatsappModal && isClientBeexcc" @close="whatsappModal = false" /> -->
  <WhatsappAutoSetup class="setup-modal" :open="whatsappModal" @close="whatsappModal = false"/>

  <WebChatChannels
    class="setup-modal"
    :open="showWebChatModal"
    @close="showWebChatModal = false"
    v-if="showWebChatModal"
  />

  <voice-channel
    v-if="voiceModal"
    class="setup-modal"
    :open="voiceModal"
    @close="voiceModal = false"
  />
  <sms-channel class="setup-modal" :open="smsModal" @close="smsModal = false" />
  <EmailChannel
    v-if="emailModal"
    class="setup-modal"
    :open="emailModal"
    @close="emailModal = false"
  />

  <InstagramConfigurationModal
    v-if="instagramModal"
    class="setup-modal"
    :open="instagramModal"
    @close="instagramModal = false"
  />

  <a-modal
    title="List Contacts Modal"
    v-model:visible="ListContactsModal"
    centered
    :maskClosable="false"
  >
    <p>Contenido de la previsualización</p>
    <div v-for="contact in Listcontacts" :key="contact.id">
      <p>{{ contact.properties.firstname }} {{ contact.properties.lastname || 'sin apellido' }} - {{ contact.properties.email || 'sin email' }}</p>
    </div>
  </a-modal>
</template>

<script>
import facebookChannel from "@/app/channels/components/modals/messengerChat/facebookChannel.vue";
import whatsappChannels from "@/app/channels/components/modals/whatsapp/WhatsappChannels.vue";
import WhatsappAutoSetup from "@/app/channels/components/modals/whatsapp/WhatsappAutoSetup.vue";
import WebChatChannels from "@/app/channels/components/modals/webChat/Index.vue";
import CardChannels from "@/app/channels/components/cards/CardChannel.vue";
import SmsChannel from "@/app/channels/components/modals/sms/SmsChannel.vue";
import VoiceChannel from "@/app/channels/components/modals/voice/VoiceChannel.vue";
import EmailChannel from "@/app/channels/components/modals/email/EmailChannel.vue";
import InstagramConfigurationModal from "@/app/channels/components/modals/instagram/InstagramConfigurationModal.vue";
import { CompanyName } from "@/app/shared/utils/constants";

import { channelsConfig } from "@/app/channels/utils/constants";
import { hubspotService } from "@/app/channels/services/hubspot.services";
import httpManager from "@/app/shared/utils/httpManager";
import { computed, onMounted, ref, watch, createVNode } from "vue";
import { useStore } from "vuex";
import { planConfigServices } from "@/app/common/services/PlanConfigServices";
import { message, Modal } from "ant-design-vue";
import { ExclamationCircleFilled } from "@ant-design/icons-vue";
import { checkIncompleteAttempt } from "@/app/channels/services/whatsappAutoSetup";

export default {
  name: "ChannelsSetupTemplate",
  components: {
    CardChannels,
    facebookChannel,
    whatsappChannels,
    WhatsappAutoSetup,
    WebChatChannels,
    SmsChannel,
    VoiceChannel,
    EmailChannel,
    InstagramConfigurationModal,
  },
  data() {
    const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/conexiones/canales-de-comunicacion/`;

    const store = useStore();
    const user = computed(() => store.getters["getDataUser"]);
    const dataPlan = computed(() => store.getters["getDataPlanDetails"]);

    return {
      voice: 1,
      sms: 2,
      whatsapp: 4,
      webchat: 5,
      facebook: 6,
      email: 9,
      channelsCustomerConfig: channelsConfig,
      facebookModal: false,
      whatsappModal: false,
      smsModal: false,
      showWebChatModal: false,
      voiceModal: false,
      emailModal: false,
      instagramModal: false,
      DOCS_URL,
      CompanyName,
      Listcontacts: "",
      ListContactsModal: false,
      dataPlan,
    };
  },
  mounted() {
    this.$store.dispatch("fetchAllChannelsCustomers");
    this.$store.dispatch("fetchAllCountries");
    this.$store.dispatch("fetchLoggedBusiness");
  },
  computed: {
    channelsCustomer() {
      return this.$store.getters["getChannelsCustomersList"];
    },
    user() {
      return this.$store.getters["getDataUser"];
    },
  },
  methods: {
    async handleOpenModal(event) {
      switch (event) {
        case "Messenger":
          this.facebookModal = true;
          break;
        case "WhatsApp":
          await this.handleWhatsAppFlow();
          break;
        case "Chat Inbound":
          this.showWebChatModal = true;
          break;
        case "SMS":
          this.smsModal = true;
          break;
        case "Telefonica":
          this.voiceModal = true;
          break;
        case "Correo":
          this.emailModal = true;
          break;
        case "Instagram":
          this.instagramModal = true;
          break;
        default:
          break;
      }
    },
    async handleLoginHubSpot() {
      try {
        const response = await hubspotService.loginHubspot();
        console.log(response);
        if (response.url_redirect) {
          window.location.href = response.url_redirect;
        }
      } catch (error) {
        console.error("Error al intentar iniciar sesión en HubSpot:", error);
      }
    },
    async handleListContactsHubSpot() {
      try {
        const response = await hubspotService.listContacts();
        console.log("Contactos de HubSpot:", response);
        this.Listcontacts = response.results || [];
        this.ListContactsModal = true;
      } catch (error) {
        console.error("Error al listar contactos de HubSpot:", error);
      }
    },
    async handleWhatsAppFlow() {
      try {
        const response = await checkIncompleteAttempt();
        if (response.has_incomplete) {
          this.showIncompleteAttemptModal(response.name);
        } else {
          this.whatsappModal = true;
        }

      } catch (error) {
        this.whatsappModal = true;
      }
    },
    showIncompleteAttemptModal(name) {
      Modal.confirm({
        title: "Tienes una solicitud incompleta de WhatsApp Business.",
        wrapClassName: "modal-open-configuration",
        icon: createVNode(ExclamationCircleFilled),
        content: createVNode('div', {}, [
          'Para integrar una nueva cuenta de WhatsApp Business, debes ',
          createVNode('span', { style: 'font-weight: 600' }, 'finalizar o cancelar la solicitud incompleta '),
          'con el nombre “',
          name, '” ',
          'desde Mis canales.',
        ]),
        okText: "Entendido",
        cancelButtonProps: { style: { display: "none" } },
        centered: true,
        width: 425,
        onOk: () => this.whatsappModal = false,
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.channelsSetup
  padding: 8px 20px

p
  margin: 0

.container
  height: calc(100vh - 156px)
  overflow: auto

.section-channels-cards
  width: 100%
  display: flex
  flex-wrap: wrap
  justify-content: left
  align-items: center
  gap: 25px
  margin-top: 2%

.title
  font-weight: 600
  font-size: $font-large
  line-height: 28px
  text-align: center
  color: $gray-9
  margin-bottom: $margin-tiny
  margin-top: 30px
.description
  font-size: $font-normal
  line-height: 22px
  text-align: center
  color: $gray-9

:global(.modal-open-configuration .ant-modal-confirm-body)
  align-items: flex-start !important
:global(.modal-open-configuration .anticon)
  margin-top: 3px !important
</style>
